const getIngredientAltText = (ingredientType, ingredientTitle) => {
  let altText;
  switch (ingredientType) {
    case 'Food':
      altText = `${ingredientTitle} party food ideas and inspiration`;
      break;
    case 'Venue Settings':
      altText = `${ingredientTitle} party venue ideas and inspiration`;
      break;
    case 'Beverage':
      altText = `${ingredientTitle} drink inspiration and party ideas`;
      break;
    case 'Creative Detail':
      altText = `${ingredientTitle} party inspiration`;
      break;
    default:
      altText = ingredientTitle;
      break;
  }
  return altText;
};

export default getIngredientAltText;
